import angular from 'angular';

import component from './menu-modifier-group.component';

const MenuModifierGroup = angular
    .module('control-room.commons.content.components.menu-modifier-group', [])
    .component('crMenuModifierGroup', component);

export default MenuModifierGroup;
